import Infoblock from './Infoblock.vue';

export default Infoblock;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/contract/components/infoblock/index.ts